import styled from "styled-components";

export const ShortcutWidgetStyled = styled.div`
  padding: 0 20px 5px 20px;
  .shortcut_row {
    display: flex;
    justify-content: center;
    column-gap: 20px;
    .shortcut_item {
      width: 80px;
      display: flex;
      align-items: center;
      flex-direction: column;
      cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
      .shortcut_icon {
        margin-bottom: 10px;
      }
      .shortcut_title {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) =>
          `${theme.FONT.STYLE.GT_AMERICA_STANDARD_REGULAR},${theme.FONT.STYLE.PROMPT_REGULAR}`};
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .shortcut_row {
      justify-content: space-around;
      .shortcut_item {
        width: 77px;
        .shortcut_icon {
          margin-bottom: 5px;
        }
      }
    }
  }
`;
